export default function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-yellow-500/10 via-black to-yellow-600/10 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/90"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 bg-yellow-500/20 border border-yellow-500/40 rounded-full px-4 py-2 mb-6">
            <i className="ri-star-fill text-yellow-500"></i>
            <span className="text-yellow-500 font-semibold text-sm">Premium Mobile Detailing</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4">
            Ready for a 
            <span className="text-yellow-500 block md:inline"> Showroom Shine?</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Get your quote now and experience the convenience of premium mobile detailing. We come to you—home, office, or anywhere in the Miami area.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <a
            href="sms:+17863272644"
            className="bg-yellow-500 text-black px-12 py-5 rounded-full text-xl font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl shadow-yellow-500/50"
          >
            <i className="ri-message-3-line text-2xl"></i>
            Text for Quote
          </a>
          <a 
            href="https://wa.me/17863272644" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-green-600 text-white px-12 py-5 rounded-full text-xl font-bold hover:bg-green-500 transition-all inline-flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl shadow-green-600/50"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            WhatsApp Us
          </a>
        </div>

        <div className="flex items-center justify-center gap-2 text-gray-400 mb-8">
          <i className="ri-phone-line text-yellow-500"></i>
          <span className="text-lg font-semibold">(786) 327-2644</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="flex items-center justify-center gap-2 text-gray-400">
            <i className="ri-time-line text-yellow-500"></i>
            <span className="text-sm">Fast response</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-400">
            <i className="ri-map-pin-line text-yellow-500"></i>
            <span className="text-sm">30-mile radius</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-400">
            <i className="ri-shield-check-line text-yellow-500"></i>
            <span className="text-sm">Professional results</span>
          </div>
        </div>
      </div>
    </section>
  );
}
